<script>
import CalendarEvent from "./CalendarEvent";
import VTooltipWrapper from "../../../../common/v-tooltip-wrapper.vue";

export default {
    name: "calendar-event-title",
    components: {VTooltipWrapper},
    props: {
        event: {
            type: CalendarEvent,
            required: true
        },
        settings: {},
        showOnlyTitle: Boolean
    }
}
</script>

<template>
    <v-tooltip-wrapper v-if="event.getDisplayInformation(settings)">
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="calendar-event-title">
                {{event.getTitleAndTime(showOnlyTitle)}}
            </span>
        </template>
        <div class="icon-in-tooltip-container calendar-event-title-tooltip">
            <span>{{event.getTitleAndTime(true)}}</span>
            <span>{{event.timestamp}}</span>
        </div>
    </v-tooltip-wrapper>
</template>

<style lang="scss" scoped>
.calendar-event-title-tooltip {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    gap: 8px;
}

.calendar-event-title {
    align-self: center;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    z-index: 1;
}
</style>
